const submissionUploadStatus = {
    UPLOAD_INACTIVE : 0,

    UPLOAD_PENDING : 1,

    UPLOAD_IN_PROGRESS : 2,

    UPLOAD_FAILED : 3,

    UPLOAD_SUCCEEDED : 4

};

angular.module('gw-um-j2js')
    .constant('submissionUploadStatus', submissionUploadStatus);